import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaTelegram, FaMicrosoft, FaArrowRight } from 'react-icons/fa';

const CHANNEL_META = {
  telegram: {
    label: 'Telegram',
    description: 'Topluluğumuza katılın, duyuruları takip edin ve anlık destek alın.',
    cta: 'Kanala Katıl',
    icon: FaTelegram,
    accent: 'from-sky-500/25 to-blue-700/10'
  },
  teams: {
    label: 'Microsoft Teams',
    description: 'Kurumsal iş birlikleri ve sponsorluk görüşmeleri için bize ulaşın.',
    cta: 'Görüşme Talep Et',
    icon: FaMicrosoft,
    accent: 'from-purple-500/25 to-indigo-700/10'
  }
};

const Contact = () => {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await axios.get('/api/contacts');
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  if (contacts.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="text-2xl md:text-3xl font-bold text-center text-gold mb-8 drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]">
        Bize Ulaşın
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
        {contacts.map((contact) => {
          const meta = CHANNEL_META[contact.type.toLowerCase()] || {
            label: contact.type,
            description: 'Bu kanal üzerinden bizimle iletişime geçebilirsiniz.',
            cta: 'Bize Ulaşın',
            icon: FaTelegram,
            accent: 'from-gold/20 to-amber-700/10'
          };
          const Icon = meta.icon;

          return (
            <a
              key={contact.id}
              href={contact.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-2xl border-2 border-gold/25 hover:border-gold bg-gradient-card p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_30px_rgba(212,175,55,0.35)]"
            >
              <div className={`pointer-events-none absolute inset-0 bg-gradient-to-br ${meta.accent} opacity-70`}></div>
              <div className="relative z-10 flex items-start gap-4">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-black/30 text-gold text-2xl border border-gold/30 shadow-inner group-hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] transition-all duration-300">
                  <Icon />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-lg md:text-xl font-bold text-white group-hover:text-gold transition-colors">
                    {contact.label || meta.label}
                  </h3>
                  <p className="mt-1.5 text-sm text-white/65 leading-relaxed">{meta.description}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-gold">
                    {meta.cta}
                    <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default Contact;
